import { ErrorCircleIcon } from "tdesign-icons-react";

/**
 * 后台管理 - 无访问权限页（HTTP 403）
 *
 * 触发条件：
 * - 当前太湖登录用户不在七彩石 ADMIN_USERS 名单中
 * - 后端任一后台接口（含 /user/me）返回 403 → 前端跳转到此页
 *
 * 设计差异（与门户 NoPermission 区别）：
 * - 这是「太湖已登录但不是管理员」的场景，没有「重新登录」逻辑（重新扫码也没用），
 *   只提供联系管理员的提示。
 *
 * 视觉：参考 TDesign Starter（React 版）的 403 页结构，使用 TDesign 设计 token 拼装，
 *      不引入额外依赖（tdesign-react 至 1.17 仍未导出 Result 组件）。
 */
const Forbidden = () => {
  // 这里有意不放「重新登录 / 返回首页」按钮：
  // - 非管理员太湖用户已登录，不需要再扫码；
  // - 点回首页只会再次被 AdminGuard 踢回 /403，反而误导用户。
  // 管理员把账号加入 ADMIN_USERS 后，用户自行刷新页面即可恢复访问。
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--td-bg-color-page, #f5f7fa)",
        padding: 24,
      }}
    >
      <div
        style={{
          width: 480,
          maxWidth: "100%",
          padding: "48px 32px",
          textAlign: "center",
          background: "var(--td-bg-color-container, #fff)",
          borderRadius: "var(--td-radius-large, 12px)",
          boxShadow: "var(--td-shadow-1, 0 1px 10px rgba(0,0,0,0.05))",
        }}
      >
        <ErrorCircleIcon
          style={{
            fontSize: 72,
            color: "var(--td-error-color, #d54941)",
            marginBottom: 16,
          }}
        />
        <div
          style={{
            fontSize: 28,
            fontWeight: 600,
            color: "var(--td-text-color-primary, #181818)",
            marginBottom: 8,
          }}
        >
          403 Forbidden
        </div>
        <div
          style={{
            fontSize: 14,
            lineHeight: 1.6,
            color: "var(--td-text-color-secondary, #595959)",
            marginBottom: 24,
          }}
        >
          抱歉，您当前不是后台管理员，暂无访问权限。
          <br />
          如需开通，请联系系统管理员。
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
